export const provinceOptions = [
  { optionval: "", optionname: "Select Province" },
  { optionval: "alberta", optionname: "Alberta" },
  { optionval: "britishcolumbia", optionname: "British Columbia" },
  { optionval: "manitoba", optionname: "Manitoba" },
  { optionval: "newbrunswick", optionname: "New Brunswick" },
  {
    optionval: "newfoundlandandlabrador",
    optionname: "Newfoundland and Labrador",
  },
  { optionval: "novascotia", optionname: "Nova Scotia" },
  { optionval: "ontario", optionname: "Ontario" },
  { optionval: "princeedwardisland", optionname: "Prince Edward Island" },
  { optionval: "saskatchewan", optionname: "Saskatchewan" },
];
